import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import { SelectTreeProps } from './type';
import TreeRender from './TreeRender';
import { cloneDeep } from 'lodash';
import { message } from 'antd';
import { enlargeIcon, narrowIcon } from './icon';

const SelectTree: ForwardRefExoticComponent<PropsWithoutRef<SelectTreeProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    handleNodeClick,
    currentSelectNode,
    data,
    onChange,
  },
  ref,
) => {
  const treeRef = useRef<any>();
  const [size, setSize] = useState(1);
  const [preLeft, setPreLeft] = useState(0);
  const [preTop, setPreTop] = useState(30);
  const [scaleH, setScaleH] = useState(300);

  const changeSize = (num: number) => {
    if (size > 3 && num > 0) {
      message.info('不能再放大了');
      return;
    }
    if (size < 0.3 && num < 0) {
      message.info('不能再缩小了');
      return;
    }
    const newSize = size + num;
    setSize(newSize);
    treeRef.current.style.transform = `scale(${newSize})`;
  };

  const onMouseDown = (e: any) => {
    const defaultX = e.clientX;
    const defaultY = e.clientY;
    treeRef.current.onmousemove = (me: any) => {
      treeRef.current.style.cursor = 'move';
      const x = me.clientX;
      const y = me.clientY;
      const nowLeft = preLeft - (defaultX - x);
      const newTop = preTop - (defaultY - y);
      treeRef.current.style.left = `${nowLeft}px`;
      treeRef.current.style.top = `${newTop}px`;
    };
  };

  const onMouseUp = () => {
    treeRef.current.style.cursor = 'default';
    treeRef.current.onmousemove = null;
    treeRef.current.onmouseup = null;
    setPreLeft(treeRef.current.offsetLeft);
    setPreTop(treeRef.current.offsetTop);
  };

  useEffect(() => {
    if (treeRef.current && treeRef.current.clientHeight && treeRef.current.clientHeight > 300) {
      setScaleH(treeRef.current.clientHeight);
    }
  }, [treeRef.current]);

  return (
    <div className={styles.tree_scale} style={{ height: `${scaleH}px` }}>
      <div className={styles.size_box}>
        <span className={styles.size_icon} onClick={() => changeSize(0.1)}>{enlargeIcon()}</span>
        <span>{`${parseInt(size * 100)}%`}</span>
        <span className={styles.size_icon} onClick={() => changeSize(-0.1)}>{narrowIcon()}</span>
      </div>
      <div
        className={styles.tree_wrap}
        ref={treeRef}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
      >
        <TreeRender
          data={data}
          currentSelectNode={currentSelectNode}
          onChange={() => {
            onChange && onChange(cloneDeep(data));
          }}
          handleNodeClick={handleNodeClick}
        />
      </div>
    </div>
  );
});

export default SelectTree;
